import type { FaireProductEntity } from "../../entity_types/product";

export const p_tsmswjpnb3: FaireProductEntity = {
  token: "p_tsmswjpnb3",
  type: "product",
  name: "Sambal Goreng Chili Topping",
  brandToken: "b_nuvyk3uha5",
  brandName: "Bungkus Bagus",
  imageUrl:
    "https://cdn.faire.com/fastly/268a580d8af5a84fcca0d245ecd5b722b2e8c1f70c385c6bade6eb8fbab52f85.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72183cf3cc25afa53869a27e24a922e1be644536d01b2a0d608fb67d8e0bcd1c.jpeg",
    "https://cdn.faire.com/fastly/1110e3c9746f783e4fd8908fc62ec0a9ceb6f9d3b54e4e2622e5f9831ff05dc1.jpeg",
    "https://cdn.faire.com/fastly/42ff98dd8b1f8ac28e0275cfd8f48e3451380b3f3d291a8d9aafbe0e0d950db0.jpeg",
    "https://cdn.faire.com/fastly/2871daeff750d88cd4f4bca564b204c3e3d9985a82732ef9bf89916a4d6d4c70.jpeg",
    "https://cdn.faire.com/fastly/ae76c5e7fefa3ff5a7598698840bead0404e52d061611542eec88b08b0d06841.jpeg",
  ],
  priceDollars: 11,
  description:
    "A fiery crunch with a flavor punch!\n\nSambal Goreng, or spicy fried shallots and garlic, is a good-on-everything topping that instantly adds a bold kick and satisfying crunch to just about any dish. Use it while you cook. Sprinkle as a final flourish. Or snack on it, straight from the jar.\n\nWe make it the old-school way: by hand, with care. This is our love letter to Bali, whose flavors belong in every pantry.\n\nVegan - Gluten-Free - Peanut-Free - Soy-Free - No Added Sugar - No Preservatives\nNet Weight: 4 oz.\nIngredients: USA grown shallots and garlic, bird’s eye chili powder, salt, non-GMO canola oil.\nShelf life: store in a cool, dry place for up to six months.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:34.268Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
